import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";


const HelpCenter = () => {

  const help = [
    { id: 1, title: 'FAQs', sub: 'Frequently asked questions and answers', button: 'Go to FAQs', link: ''},
    { id: 2, title: 'Guides', sub: 'Articles and resources to guide you', button: 'Check guides', link: ''},
    { id: 3, title: 'Support', sub: 'Contact us for more detailed support', button: 'Contact us', link: ''}
  ]


    return (
   <>
   <div className="text-center relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32">
         <img
           src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2850&q=80&blend=111827&blend-mode=multiply&sat=-100&exp=15"
           alt=""
           className="absolute inset-0 -z-10 h-full w-full object-cover overflow-hidden"
         />
         <div className="relative mx-auto px-6 lg:px-8">
           <svg
             viewBox="0 0 1266 975"
             aria-hidden="true"
             className="absolute -bottom-8 -left-96 -z-10 w-[79.125rem] transform-gpu blur-3xl sm:-left-40 sm:-bottom-64 lg:left-8 lg:-bottom-32 xl:-left-10"
           >
             <path
               fill="url(#05f95398-6ec0-404d-8f7d-a69a4504684d)"
               fillOpacity=".2"
               d="M347.52 746.149 223.324 974.786 0 630.219l347.52 115.93 223.675-411.77c1.431 190.266 49.389 498.404 229.766 208.829C1026.43 181.239 966.307-135.484 1129.51 59.422c130.55 155.925 143.15 424.618 133.13 539.473L936.67 429.884l23.195 520.539L347.52 746.149Z"
             />
             <defs>
               <linearGradient
                 id="05f95398-6ec0-404d-8f7d-a69a4504684d"
                 x1="1265.86"
                 x2="-162.888"
                 y1=".254"
                 y2="418.947"
                 gradientUnits="userSpaceOnUse"
               >
                 <stop stopColor="#776FFF" />
                 <stop offset={1} stopColor="#FF4694" />
               </linearGradient>
             </defs>
           </svg>
           <div className="mx-auto">
             <h2 className="text-base font-semibold leading-8 text-indigo-400">HELP CENTER</h2>
               <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-6xl">
                How can we help you today?
               </p>
               <p className="mt-6 text-lg leading-8 text-gray-300">
                 Search for a topic or question, check out our FAQs and guides, contact us for detailed support
               </p>
           </div>

          <div className="mx-auto lg:max-w-xl m-10">
            <form>
              <label htmlFor="default-search" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
              <div className="relative">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                      <svg aria-hidden="true" className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                  </div>
                  <input type="search" id="default-search" className="block w-full p-4 pl-10 text-sm text-gray-900 border-2 border-gray-300 rounded-full bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-transparent dark:bg-transparent dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Enter a question, topic or keyword" required/>
                  <button type="submit" className="text-white absolute right-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Search</button>
              </div>
            </form>
          </div>

         </div>
       </div>

<div className="flex flex-col items-center pb-6 px-6 sm:pb-10 sm:px-10">
  <div className="grid grid-cols-1 md:grid-cols-3 gap-y-8 md:gap-y-0 md:gap-x-6 w-full max-w-sm md:max-w-4xl -mt-16 sm:-mt-24">

{help.map((card) => (

  <div key={card.id} className="relative flex flex-col rounded-2xl shadow hover:shadow-lg overflow-hidden bg-white transition-shadow ease-in-out duration-150">

    <div className="flex flex-col flex-auto items-center p-8 text-center bg-white">
      <div className="text-gray-700 text-2xl font-semibold">{card.title}</div>
      <div className="md:max-w-40 mt-1 text-secondary">{card.sub}</div>
    </div>

    <div className="flex items-center justify-center py-4 px-8 text-blue-500 dark:text-blue-400 bg-gray-50 dark:bg-gray-50 dark:border-t">
      <a className="flex items-center" href="/">
        <span className="absolute inset-0"></span>
        <span className="font-medium">{card.button}</span>
          <svg className="w-4 h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
            <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
          </svg>
      </a>
    </div>

  </div>

  ))}

   </div>
  </div>

  <div className="mx-auto m-10">
   <div className="mt-10 text-3xl sm:text-5xl text-slate-800 dark:text-slate-100 font-extrabold leading-tight tracking-tight text-center">Most frequently asked questions</div>
   <div className="mt-2 text-xl text-center text-inherit">Here are the most frequently asked questions you may check before getting started</div>
  </div>

<div className="mx-auto w-11/12 max-w-6xl m-10">
  <div id="accordion-collapse" data-accordion="collapse">
    <h2 id="accordion-collapse-heading-1">
      <button type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-700 bg-white shadow rounded-t-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
        <span>Is there a 14-days trial?</span>
        <svg data-accordion-icon className="w-6 h-6 rotate-180 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
      </button>
    </h2>
    <div id="accordion-collapse-body-1" className="hidden" aria-labelledby="accordion-collapse-heading-1">
      <div className="p-5 font-light border border-b-0 border-gray-200 dark:border-gray-700 dark:bg-gray-900">
        <p className="mb-2 text-gray-500 dark:text-gray-400">Flowbite is an open-source library of interactive components built on top of Tailwind CSS including buttons, dropdowns, modals, navbars, and more.</p>
        <p className="text-gray-500 dark:text-gray-400">Check out this guide to learn how to <a href="/docs/getting-started/introduction/" className="text-blue-600 dark:text-blue-500 hover:underline">get started</a> and start developing websites even faster with components on top of Tailwind CSS.</p>
      </div>
    </div>
    <h2 id="accordion-collapse-heading-2">
      <button type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 bg-white shadow focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-2" aria-expanded="false" aria-controls="accordion-collapse-body-2">
        <span>What’s the benefits of the Premium Membership?</span>
        <svg data-accordion-icon className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
      </button>
    </h2>
    <div id="accordion-collapse-body-2" className="hidden" aria-labelledby="accordion-collapse-heading-2">
      <div className="p-5 font-light border border-b-0 border-gray-200 dark:border-gray-700">
        <p className="mb-2 text-gray-500 dark:text-gray-400">Flowbite is first conceptualized and designed using the Figma software so everything you see in the library has a design equivalent in our Figma file.</p>
        <p className="text-gray-500 dark:text-gray-400">Check out the <a href="https://flowbite.com/figma/" className="text-blue-600 dark:text-blue-500 hover:underline">Figma design system</a> based on the utility classes from Tailwind CSS and components from Flowbite.</p>
      </div>
    </div>
    <h2 id="accordion-collapse-heading-3">
      <button type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 bg-white shadow rounded-b-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false" aria-controls="accordion-collapse-body-3">
        <span>Is there a month-to-month payment option?</span>
        <svg data-accordion-icon className="w-6 h-6 shrink-0" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
      </button>
    </h2>
    <div id="accordion-collapse-body-3" className="hidden" aria-labelledby="accordion-collapse-heading-3">
      <div className="p-5 font-light border border-t-0 border-gray-200 dark:border-gray-700">
        <p className="mb-2 text-gray-500 dark:text-gray-400">The main difference is that the core components from Flowbite are open source under the MIT license, whereas Tailwind UI is a paid product. Another difference is that Flowbite relies on smaller and standalone components, whereas Tailwind UI offers sections of pages.</p>
        <p className="mb-2 text-gray-500 dark:text-gray-400">However, we actually recommend using both Flowbite, Flowbite Pro, and even Tailwind UI as there is no technical reason stopping you from using the best of two worlds.</p>
        <p className="mb-2 text-gray-500 dark:text-gray-400">Learn more about these technologies:</p>
        <ul className="pl-5 text-gray-500 list-disc dark:text-gray-400">
          <li><a href="https://flowbite.com/pro/" className="text-blue-600 dark:text-blue-500 hover:underline">Flowbite Pro</a></li>
          <li><a href="https://tailwindui.com/" rel="nofollow" className="text-blue-600 dark:text-blue-500 hover:underline">Tailwind UI</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>

   </>
    )
}

export default HelpCenter;
